import { useEffect, useState } from "react";
import { Button } from "antd";
import { initAnalytics, isAnalyticsConfigured } from "../analytics";

const STORAGE_KEY = "pa_cookie_accepted";

function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
        } catch {
            setVisible(true);
        }
    }, []);

    const accept = () => {
        try {
            localStorage.setItem(STORAGE_KEY, new Date().toISOString());
        } catch {
            // localStorage unavailable — banner will reappear next load.
        }
        setVisible(false);
        // Kick off GA4 now that consent has just been granted; the
        // pageload visit will fire on the next route change.
        initAnalytics();
    };

    if (!visible) return null;

    return (
        <div
            role="dialog"
            aria-label="Cookie notice"
            style={{
                position: "fixed",
                left: 16,
                right: 16,
                bottom: 16,
                zIndex: 1000,
                display: "flex",
                justifyContent: "center",
                pointerEvents: "none",
            }}
        >
            <div
                className="gt-card"
                style={{
                    maxWidth: 720,
                    width: "100%",
                    padding: 16,
                    display: "flex",
                    gap: 16,
                    alignItems: "center",
                    flexWrap: "wrap",
                    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
                    pointerEvents: "auto",
                }}
            >
                <div
                    style={{
                        flex: "1 1 240px",
                        color: "var(--gt-text)",
                        fontSize: 14,
                        lineHeight: 1.5,
                    }}
                >
                    Planamoto uses essential cookies and local storage to keep
                    you signed in and to remember your preferences
                    {isAnalyticsConfigured()
                        ? ", plus Google Analytics to understand which pages get used"
                        : ""}
                    . See our <a href="/privacy">Privacy Policy</a> for details.
                </div>
                <Button type="primary" onClick={accept}>
                    Accept
                </Button>
            </div>
        </div>
    );
}

export default CookieBanner;
